const state = {
  cameFromRouteName: undefined
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/exercises/state.js